/** @module ProductSpec/NewFromApparelBOMController */
define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/NewFrom",
	"csi/xml"
], function(declare,reflection,NewFrom,xml) {

	return declare(NewFrom, {
		/**
		 * @override
		 * Add ApparelBOMSubtype and BOMProductColors to the server operation and consume the values
		 * so they don't also get processed as ChangeAttributes by the framework
		 */
		toWriterRequest: function() {
			var fd = this.getFormData();
			var call = this.inherited(arguments);
			call.addParameter("ApparelBOMSubtype", xml.ATTR_REF, fd.getFieldValue(reflection.ATTR_SUBTYPE, true));
			call.addParameter("BOMProductColors", xml.ATTR_REFLIST, fd.getFieldValue("BOMProductColors", true));
			return call;
		},

		/**
		 * @override
		 * Blank out the BOMProductColors when copying from a BOM of a different Style
		 */
		onFormData(fd) {
			const {m_aSources, m_urlParent} = this;
			const source = m_aSources[0];

			if (source && (source.__Parent__ !== m_urlParent)) {
				fd.setFieldInitialValue("BOMProductColors", []);
			}

			this.inherited(arguments);
		}
	});
});